import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import NumberFormat from 'react-number-format';

import { FontSizes } from '../../../../core/config/mainTheme';
import { InterestRateRow } from '../../../../pages/Benchmark/BenchmarkPage/BenchmarkTabs/ResultsPanel/ResultsInput/InterestRatesModal';

interface Props extends ICellRendererParams {
  data: InterestRateRow;
  year: number;
}

const BenchmarkInterestRateCellRenderer: React.FC<Props> = ({ data, year }) => {
  const classes = useStyles();
  const availableRatesAtYear = data.rates.find((ir) => ir.year === year);
  if (!availableRatesAtYear) {
    return <Box className={classes.editPointer}>-</Box>;
  }

  const { companyRate, countryRate } = availableRatesAtYear;
  const companyRateDefined = companyRate !== null && companyRate !== undefined;
  const countryRateDefined = countryRate !== null && countryRate !== undefined;

  if (!companyRateDefined && !countryRateDefined) {
    return <Box className={classes.editPointer}>-</Box>;
  } else if (companyRateDefined) {
    return (
      <div className={classNames([classes.combinedRates, classes.editPointer])}>
        <NumberFormat value={companyRate} displayType={'text'} thousandSeparator={true} />{' '}
        <>
          (
          <span className={classes.overriddenRate}>
            {countryRateDefined && (
              <NumberFormat value={countryRate} displayType={'text'} thousandSeparator={true} />
            )}
            {!countryRateDefined && '-'}
          </span>
          )
        </>
      </div>
    );
  } else {
    return (
      <Box className={classes.editPointer}>
        <NumberFormat
          value={countryRate}
          displayType={'text'}
          thousandSeparator={true}
          className={classes.editPointer}
        />
      </Box>
    );
  }
};

const useStyles = makeStyles(() => ({
  editPointer: {
    cursor: 'pointer',
  },
  combinedRates: {
    fontWeight: FontSizes.fontWeight.bold,
  },
  overriddenRate: {
    textDecoration: 'line-through',
  },
}));

export default BenchmarkInterestRateCellRenderer;
